// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Form
//https://shopware-pwa-docs.vuestorefront.io/guide/CMS.html#block
const tData = {
    name: "test-123",
    type: "container",
    slots: [
        {
            type: "g-row-column-one",
            config: {
                row: {
                    class: "row"
                },
                column: {
                    class: "col"
                }
            },
            slots: [
                {
                    type: "g-cms-text",
                    config: {
                        class: "h4"
                    },
                    data: {
                        content: "Allgemein"
                    }
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Firma*"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Steuernummer"
                            }
                        }
                    ]
                },
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Umsatzsteuer-ID"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-one",
            config: {
                row: {
                    class: "row"
                },
                column: {
                    class: "col"
                }
            },
            slots: [
                {
                    type: "g-cms-text",
                    config: {
                        class: "h4"
                    },
                    data: {
                        content: "Adresse"
                    }
                },
            ]
        },
        {
            type: "g-cms-text-image",
            slots: [
                {
                    type: "g-cms-text",
                    slot: "left",
                    config: {
                        content: {
                            type: "img",
                            config: {
                                class: "img-fluid",
                                src: "https://via.placeholder.com/640x360"
                            }
                        }
                    }
                },
                {
                    type: "g-cms-text",
                    slot: "right",
                    config: {
                        content: {
                            type: "g-cms-text",
                            data: {
                                content: "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p><p>Aenean commodo ligula eget dolor. Aenean massa.</p><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu</p>"
                            }
                        }
                    }
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-12"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Zusatz"
                            }
                        }
                    ]
                },
                {
                    type: "g-column",
                    config: {
                        class: "col-12"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Straße"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-4"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Plz"
                            }
                        }
                    ]
                },
                {
                    type: "g-column",
                    config: {
                        class: "col-8"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Ort"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-12"
                    },
                    slots: [
                        {
                            type: "g-select-field",
                            config: {
                                label: "Land",
                                valueExpr: "key",
                                displayExpr: "caption",
                                itemSource: [
                                    {
                                        key: "de",
                                        caption: "Deutschland",
                                    },
                                    {
                                        key: "at",
                                        caption: "Österreich",
                                    }
                                ]
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-one",
            config: {
                row: {
                    class: "row"
                },
                column: {
                    class: "col"
                }
            },
            slots: [
                {
                    type: "g-cms-text",
                    config: {
                        class: "h4"
                    },
                    data: {
                        content: "Ansprechpartner"
                    }
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Vorname"
                            }
                        }
                    ]
                },
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Nachname"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-12"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "E-Mail-Adresse"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-12"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Abteilung"
                            }
                        }
                    ]
                },
            ]
        },
        {
            type: "g-row-column-multi",
            config: {
                row: {
                    class: "row"
                }
            },
            slots: [
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Telefon"
                            }
                        }
                    ]
                },
                {
                    type: "g-column",
                    config: {
                        class: "col-6"
                    },
                    slots: [
                        {
                            type: "g-text-field",
                            config: {
                                label: "Mobil-Telefon"
                            }
                        }
                    ]
                },
            ]
        },
    ]
};
const tData2 = {
    name: 'test-456',
    type: 'container',
    toolbar: {
        commands: [
            {
                title: "Prüfen"
            },
            {
                title: "Reorganisieren"
            }
        ]
    },
    slots: [
        {
            type: "g-cms-field-group",
            config: {
                title: "Allgemein",
                subTitle: "Bitte geben Sie alle allgemeinen Funktionen ein",
            },
            slots: [
                //{
                //    type: "g-row-column-multi",
                //    config: {
                //        row: {
                //            class: ""
                //        },
                //        columns: [
                //            {
                //                class: "col-2"
                //            },
                //            {
                //                class: "col-10"
                //            }
                //        ]
                //    },
                //    slots: [
                //        {
                //            type: "g-text-field",
                //            config: {
                //                label: "Telefon"
                //            }
                //        },
                //        {
                //            type: "g-text-field",
                //            config: {
                //                label: "Mobil-Telefon"
                //            }
                //        }
                //    ]
                //},
                {
                    type: "g-text-field",
                    config: {
                        label: "Name"
                    }
                },
                {
                    type: "g-text-area",
                    config: {
                        label: "Inhalt",
                        inputAttr: {
                            isAutoFill: true,
                            language: "markdown",
                            isMinimapEnabled: false
                        },
                        row: {
                            class: "flex-grow-1"
                        }
                    }
                }
            ]
        }
    ]
};
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page-2',
    // #endregion
    data: () => ({
        content: tData
    }),
    methods: {
        onCommand(cmd) {
            alert(cmd.title);
        },
        onSave() {
            alert('Save');
        },
        onCancel() {
            alert('Cancel');
        },
        onTools() {
            host.notification.showModal2(host.components.getComponent('g-prototyp-page'), { documentType: 'cart', documentID: '010fca47-700a-49f0-8e9d-f62fd529eb5d' }, { variant: "slide", position: "end", size: "default" });
        }
    }
});
// #endregion
